// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1y3Yq","buttons":"SendReceipts_buttons__2MpqT","email":"SendReceipts_email__1KESU","bookApptTitle":"SendReceipts_bookApptTitle__2fczY"};